export const tag = {
    labels: {
        code: "Código",
        description: "Descrição",
        edit_tag: "Editar Tag",
        name: "Nome",
        tag: "Tag",
        tags: "Tags",
        slug: "Slug",
    },
    placeholders: {
        description: "Informe a descrição",
        name: "Informe o nome",
        slug: "Exe: nome-da-url",
    },
    modals: {
        titles: {
            add_tag: "Adicionar Tag",
            edit_tag: "Editar Tag",
            del_tag: "Excluir Tag",
        },
        messages: {
            del_tag: "Você deseja mesmo excluir o tag <strong>{name}</strong>?<br/>Todos os relacionamentos desta tag serão excluídos.",
        },
    },
    texts: {
    },
};
